import { Component } from 'react';
import { connect } from 'react-redux';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { getBookInfo as getBookInfoSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import { LINK_TYPES, MEETING_TYPES } from 'MeetingsBase/constants/enums';
import get from 'transmute/get';
import DatePicker from 'MeetingsLib/components/schedule/date/DatePickerV2';
import ProfileHeader from 'MeetingsLib/components/header/ProfileHeader';
import ColoredCard from 'MeetingsLib/components/decorative/ColoredCard';
import OpenPaidMeetingPrice from 'MeetingsLib/components/payments/OpenPaidMeetingPrice';
import { getDisplayAvatarOption } from 'MeetingsLib/utils/utils';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getPaymentLinkInfo, getPaidMeetingsAvailableSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getPaidMeetingPrice } from 'MeetingsLib/selectors/PaymentStatusSelectors';
import { Spacer } from 'foundations-components/components/Spacer';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class DatePickerSection extends Component {
  render() {
    const {
      avatar,
      companyAvatar,
      displayAvatarOption,
      branding,
      compact,
      headline,
      profile,
      setEventDate,
      isSalesStarter,
      DatePickerMarker,
      TimePickerMarker,
      linkType,
      isPaidMeeting,
      paidMeetingInfo,
      paidMeetingPrice,
      isPreviewed
    } = this.props;
    const isPersonal = linkType === LINK_TYPES.get(MEETING_TYPES.PERSONAL);
    const avatarUrl = getDisplayAvatarOption(displayAvatarOption, avatar, companyAvatar, isPersonal);
    return /*#__PURE__*/_jsxs(TFlex, {
      blockSize: "100%",
      "data-test-id": "date-picker-section",
      direction: "column",
      children: [/*#__PURE__*/_jsxs(ColoredCard, {
        branding: branding,
        isSalesStarter: isSalesStarter,
        compact: compact,
        children: [/*#__PURE__*/_jsx(ProfileHeader
        /*  @ts-ignore Jun-18-2025, 19:10UTC fix types  */, {
          avatar: avatarUrl,
          booked: false,
          headline: headline,
          profile: profile
        }), isPaidMeeting && compact && /*#__PURE__*/_jsx(View, {
          display: "block",
          marginInline: "auto",
          padding: "200",
          typography: "body-200",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "payments.priceHeader",
            options: {
              price: paidMeetingPrice === 0 ? /*#__PURE__*/_jsx(OpenPaidMeetingPrice
              /*  @ts-ignore Jun-18-2025, 19:10UTC fix runtime - paidMeetingInfo potentially undefined */, {
                currency: paidMeetingInfo.currency
              }) : /*#__PURE__*/_jsx(FormattedIntlCurrency
              /*  @ts-ignore Jun-18-2025, 19:10UTC fix runtime - paidMeetingPrice potentially undefined */, {
                value: paidMeetingPrice
                /*  @ts-ignore Jun-18-2025, 19:10UTC fix runtime - paidMeetingInfo potentially undefined */,
                currencyCode: paidMeetingInfo.currency
              })
            }
          })
        }), /*#__PURE__*/_jsx(DatePicker, {
          compact: compact,
          profile: profile,
          branding: branding,
          setEventDate: setEventDate,
          DatePickerMarker: DatePickerMarker,
          TimePickerMarker: TimePickerMarker,
          isPreviewed: isPreviewed
        })]
      }), compact && !isSalesStarter && /*#__PURE__*/_jsx(Spacer, {
        space: "1000"
      })]
    });
  }
}
const mapStateToProps = state => ({
  isSalesStarter: state.isSalesStarter,
  // @ts-ignore Jun-30-2025, 19:10UTC fix types
  linkType: get('linkType', getBookInfoSelector(state)),
  paidMeetingPrice: getPaidMeetingPrice(state),
  // @ts-ignore Jun-30-2025, 19:10UTC fix types
  paidMeetingInfo: getPaymentLinkInfo(state),
  isPaidMeeting: getPaidMeetingsAvailableSelector(state)
});
export default connect(mapStateToProps, Object.assign({}, FormActions))(DatePickerSection);